module.exports = __webpack_public_path__ + "img/brightness_medium.c24f3688.svg";